export enum UserMessageTypeEnum {
	USER_MSG= 'user_message',
	USER_SELECTED_SUGGESTION= 'user_sel_suggestion',
	WIDGET_COMMAND= 'widget_command',
}

export const UserMessageTypeFromIndex: {[id: number]: UserMessageTypeEnum} = {
	0: UserMessageTypeEnum.USER_MSG,
	1: UserMessageTypeEnum.USER_SELECTED_SUGGESTION,
	2: UserMessageTypeEnum.WIDGET_COMMAND,
};
export default UserMessageTypeEnum;
